<div class="not-found-container">
  <div class="content-wrapper">
    <div class="error-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 48 48" class="animated-svg">
        <g id="ico-error-tramitfly-black" transform="translate(-981 -783)">
          <rect id="Rectángulo_1348" data-name="Rectángulo 1348" width="48" height="48" transform="translate(981 783)" fill="none" style="mix-blend-mode: multiply;isolation: isolate"/>
          <path id="Trazado_4152" data-name="Trazado 4152" d="M0,5.257a5.257,5.257,0,1,1,5.258,5.257A5.263,5.263,0,0,1,0,5.257M31.421,30.544A3.425,3.425,0,0,1,28.6,32a3.5,3.5,0,0,1-3.289-2.363,8.8,8.8,0,0,0-16.623,0A3.028,3.028,0,0,1,5.4,32a3.427,3.427,0,0,1-2.832-1.444,3.48,3.48,0,0,1-.442-3.2,15.745,15.745,0,0,1,29.75,0,3.468,3.468,0,0,1-.451,3.187M35.4,2.289l-7.022,8.076a1.178,1.178,0,0,1-1.635.03L21.92,5.586a1.03,1.03,0,0,1-.055-1.494c1.265-1.059,2.72-.482,4.763,1.069a1.2,1.2,0,0,0,1.635-.03l3.829-3.952A2.32,2.32,0,0,1,35.4,1.157a.8.8,0,0,1,0,1.132" transform="translate(988.262 791.13)"/>
        </g>
      </svg>
    </div>

    <div class="error-content">
      <h1 class="main-title">¡Ups! Parece que te perdiste en el camino.</h1>
      <p class="subtitle">Esta página no existe… pero tranquilo, todos nos equivocamos.</p>
      <p class="message">Regresa al inicio y sigue explorando.</p>

      <div class="actions">
        <button
          type="button"
          class="p-button p-button-primary home-button"
          (click)="goToHome()">
          <i class="pi pi-home"></i>
          Ir al inicio
        </button>

        <button
          type="button"
          class="p-button p-button-outlined back-button"
          (click)="goBack()">
          <i class="pi pi-arrow-left"></i>
          Regresar
        </button>
      </div>
    </div>
  </div>

  <div class="decoration">
    <div class="floating-shape shape-1"></div>
    <div class="floating-shape shape-2"></div>
    <div class="floating-shape shape-3"></div>
  </div>
</div>
